module.exports = __webpack_public_path__ + "static/media/icon-infobox.252a3c05.svg";